import { API_BASE_URL } from '../config';
import { getBearerAuthHeaders } from '../utils/authFetchHeaders';

/* "My strategies": the signed-in user's own strategies (personal only). */

const BASE = `${API_BASE_URL}/api/personal-strategies`;

async function call(path = '', { method = 'GET', body } = {}) {
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: { ...getBearerAuthHeaders(), ...(body ? { 'Content-Type': 'application/json' } : {}) },
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data.success === false) {
    const err = new Error(data.error || `Request failed (${res.status})`);
    err.requiresPro = Boolean(data.requiresPro) || res.status === 403;
    throw err;
  }
  return data;
}

export const listMyStrategies = () => call('');
export const createMyStrategy = (name, startingCapital) => call('', { method: 'POST', body: { name, startingCapital } });
export const updateMyStrategy = (id, patch) => call(`/${id}`, { method: 'PATCH', body: patch });
export const deleteMyStrategy = (id) => call(`/${id}`, { method: 'DELETE' });
export const importMyStrategyCsv = (id, csv, { mode = 'replace', preview = false } = {}) => call(`/${id}/csv`, { method: 'POST', body: { csv, mode, preview } });
export const getMyStrategySeries = (id) => call(`/${id}/series`);
export const getMyStrategyWebhook = (id) => call(`/${id}/webhook`);
export const newMyStrategyWebhook = (id) => call(`/${id}/webhook`, { method: 'POST' });
export const removeMyStrategyWebhook = (id) => call(`/${id}/webhook`, { method: 'DELETE' });

/** The public URL a strategy's webhook posts to. */
export const myStrategyWebhookUrl = (token) => `${API_BASE_URL}/api/personal-strategies/hook/${token}`;

/** Send a test message through the real webhook URL (marks it live, stores nothing). */
export async function sendMyStrategyTest(token) {
  const res = await fetch(myStrategyWebhookUrl(token), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ test: true, symbol: 'TEST', side: 'long', quantity: 1, pnl: 0, time: new Date().toISOString() }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data.success) throw new Error(data.error || 'The test didn’t go through.');
  return data;
}
